import React from 'react';

export default () => (
  <svg
    focusable='false'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M11.929 8.253l.019-.001a.748.748 0 0 1 .582.218l5.858 5.858a.747.747 0 0 1 .215.448.75.75 0 0 1-.732.916H6.014a.75.75 0 0 1-.75-.75l.004.082a.75.75 0 0 1 .202-.696l5.857-5.858a.748.748 0 0 1 .602-.217zm0 1.737l-4.203 4.202h8.405L11.929 9.99z' />
  </svg>
);
